/**
 * Display formatting for table column labels.
 *
 * Column keys such as "PRODUCT NAME" are also lookup keys for cells, widths,
 * filters and saved views, so format only at render time and never store the
 * result.
 */

const ACRONYMS = new Set([
  "ASN",
  "ATA",
  "ATD",
  "B2B",
  "BOM",
  "CBM",
  "ERP",
  "ETA",
  "ETD",
  "GST",
  "ID",
  "NSP",
  "PO",
  "SKU",
  "SOH",
  "UOM",
  "URL",
  "VAT",
]);

const LABEL_OVERRIDES = {
  "#": "#",
};

const formatWord = (word, isFirst) => {
  if (!word) return word;
  const bare = word.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
  if (ACRONYMS.has(bare)) return word.toUpperCase();
  const lower = word.toLowerCase();
  return isFirst ? lower.charAt(0).toUpperCase() + lower.slice(1) : lower;
};

/**
 * Format a column key or label in sentence case, keeping known acronyms.
 *
 * Words that are only sometimes acronyms (TO, SO, NO, MO) are treated as
 * ordinary words: "TO FACILITY" reads "To facility", "ORDER NO" reads
 * "Order no".
 *
 * @param {*} label
 * @returns {*} The formatted string, or the input unchanged when not a string.
 */
export const formatColumnLabel = label => {
  if (typeof label !== "string") return label;
  const trimmed = label.trim();
  if (!trimmed) return label;

  const override = LABEL_OVERRIDES[trimmed.toUpperCase()];
  if (override) return override;

  let seenWord = false;
  return trimmed
    .split(/(\s+|\/|-)/)
    .map(part => {
      if (!/[A-Za-z]/.test(part)) return part;
      const formatted = formatWord(part, !seenWord);
      seenWord = true;
      return formatted;
    })
    .join("");
};
